(function() {
'use strict';

const DS = angular.module('dashboard');
DS.directive('visitedHotelItem', function() {
    return {
        restrict: 'E',
        replace: false,
        templateUrl: 'partials/dashboard/VisitedHotelDetails',
        scope: {
            item: '='
        }
    };
});
})();
